import { render, staticRenderFns } from "./ApprovalReference.vue?vue&type=template&id=b905d382&scoped=true"
import script from "./ApprovalReference.vue?vue&type=script&lang=js"
export * from "./ApprovalReference.vue?vue&type=script&lang=js"
import style0 from "./ApprovalReference.vue?vue&type=style&index=0&id=b905d382&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b905d382",
  null
  
)

export default component.exports